var _rect, _path, _path2, _path3, _path4, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.01709,
    y: 0.875,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89209 10.625H9.80876H25.1421",
    stroke: "#051C48",
    strokeWidth: 1.54867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2253 10.6248V24.0415C23.2253 24.5498 23.0233 25.0373 22.6639 25.3968C22.3044 25.7562 21.8169 25.9582 21.3086 25.9582H11.7253C11.2169 25.9582 10.7294 25.7562 10.37 25.3968C10.0105 25.0373 9.80859 24.5498 9.80859 24.0415V10.6248M12.6836 10.6248V8.70817C12.6836 8.19984 12.8855 7.71233 13.245 7.35288C13.6044 6.99344 14.0919 6.7915 14.6003 6.7915H18.4336C18.9419 6.7915 19.4294 6.99344 19.7889 7.35288C20.1483 7.71233 20.3503 8.19984 20.3503 8.70817V10.6248",
    stroke: "#051C48",
    strokeWidth: 1.54867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6006 15.4165V21.1665",
    stroke: "#051C48",
    strokeWidth: 1.54867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4336 15.4165V21.1665",
    stroke: "#051C48",
    strokeWidth: 1.54867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.01709,
    y: 0.875,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#A5BBE2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/deleteicon.5df568d708ef4f2325bd24d3f451b406.svg";
export { ForwardRef as ReactComponent };